export const AI_CASES_LINK = "https://ai-cases.mlhub.ru";
